import type { ComponentProps } from 'react';

import { cn } from '../cn';
import { commonIconClassName } from './common';

export const ArrowLeft = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path d="M19 12H5M5 12L12 19M5 12L12 5" className="fill-none stroke-current" />
  </svg>
);

export const ArrowRight = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path d="M5 12H19M19 12L12 5M19 12L12 19" className="fill-none stroke-current" />
  </svg>
);

export const FlipBackward = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M3 9H16.5C18.9853 9 21 11.0147 21 13.5C21 15.9853 18.9853 18 16.5 18H12M3 9L7 5M3 9L7 13"
      className="fill-none stroke-current"
    />
  </svg>
);

export const ReverseLeft = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M4 7H14C17.3137 7 20 9.68629 20 13C20 16.3137 17.3137 19 14 19H4M4 7L8 3M4 7L8 11"
      className="fill-none stroke-current"
    />
  </svg>
);

export const ChevronUp = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path d="M18 15L12 9L6 15" className="fill-none stroke-current" />
  </svg>
);

export const ChevronDown = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path d="M6 9L12 15L18 9" className="fill-none stroke-current" />
  </svg>
);

export const ChevronRight = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path d="M9 18L15 12L9 6" className="fill-none stroke-current" />
  </svg>
);

export const ChevronLeft = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path d="M15 18L9 12L15 6" className="fill-none stroke-current" />
  </svg>
);

export const ChevronLeftDouble = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path d="M18 17L13 12L18 7M11 17L6 12L11 7" className="fill-none stroke-current" />
  </svg>
);

export const ChevronSelectorVertical = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path d="M7 15L12 20L17 15M7 9L12 4L17 9" className="fill-none stroke-current" />
  </svg>
);

export const ArrowCircleLeft = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      className="fill-current opacity-12"
    />
    <path
      d="M12 8L8 12M8 12L12 16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const ArrowCircleRight = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      className="fill-current opacity-12"
    />
    <path
      d="M12 16L16 12M16 12L12 8M16 12H8M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const ArrowCircleUp = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      className="fill-current opacity-12"
    />
    <path
      d="M16 12L12 8M12 8L8 12M12 8V16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const ArrowSquareUp = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <rect opacity="0.12" x="3" y="3" width="18" height="18" className="fill-current opacity-12" />
    <path
      d="M16 12L12 8M12 8L8 12M12 8V16M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const ArrowSquareDown = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <rect opacity="0.12" x="3" y="3" width="18" height="18" className="fill-current opacity-12" />
    <path
      d="M8 12L12 16M12 16L16 12M12 16V8M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const ArrowNarrowUpRight = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path d="M6 18L18 6M18 6H10M18 6V14" className="fill-none stroke-current" />
  </svg>
);

export const RefreshCw04 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M17 5.1255C19.1213 6.67103 20.5 9.17456 20.5 12.0001C20.5 16.6945 16.6944 20.5001 12 20.5001H11.5M7 18.8747C4.87867 17.3292 3.5 14.8256 3.5 12.0001C3.5 7.30568 7.30558 3.5001 12 3.5001H12.5M13 22.4001L11 20.4001L13 18.4001M11 5.6001L13 3.6001L11 1.6001"
      className="fill-none stroke-current"
    />
  </svg>
);

export const RefreshCcw05 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M8.54661 19.7675C10.9457 20.8319 13.8032 20.7741 16.2502 19.3613C20.3157 17.0141 21.7086 11.8156 19.3614 7.75008L19.1114 7.31706M4.63851 16.2502C2.2913 12.1847 3.68424 6.98619 7.74972 4.63898C10.1967 3.22621 13.0542 3.16841 15.4533 4.23277M2.49341 16.3338L5.22546 17.0659L5.95751 14.3338M18.0426 9.6659L18.7747 6.93385L21.5067 7.6659"
      className="fill-none stroke-current"
    />
  </svg>
);

export const ArrowsRight = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path d="M4 7H15M15 7L11 11M15 7L11 3M4 17H20M20 17L16 21M20 17L16 13" className="fill-none stroke-current" />
  </svg>
);

export const SwitchVertical02 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path d="M7 4V20M7 20L3 16M7 20L11 16M17 20V4M17 4L13 8M17 4L21 8" className="fill-none stroke-current" />
  </svg>
);

export const CornerUpRight = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path d="M15 14L21 8M21 8L15 2M21 8H10.5C8.01472 8 6 10.0147 6 12.5V17.5" className="fill-none stroke-current" />
  </svg>
);

export const CornerUpLeft = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M9 14L4 9M4 9L9 4M4 9H10.4C13.7603 9 15.4405 9 16.7239 9.65396C17.8529 10.2292 18.7708 11.1471 19.346 12.2761C20 13.5595 20 15.2397 20 18.6V20"
      className="fill-none stroke-current"
    />
  </svg>
);
